import axios from 'axios';
import qs from 'qs';
import { HttpRequest } from 'Api/request.utils';
import { baseUrlApis } from './index';
import { URL_CWS_API } from './constants';
import { storageGetItem, storageSetItem } from '@/utils/utils';
import { IMANAGE_CONFIG } from './drives.constants';

export default class IManageApi extends HttpRequest {
  constructor() {
    super();
    this.accessToken = null
    this.customerId = null
    this.userEmail = null
    this.iManageHost = "https://cloudimanage.com"
    this.CPDFURI = '';
    this.initialize();
  }
  initialize = () => {
    try {
      baseUrlApis.getBaseUrlBy(URL_CWS_API).then((data) => {
        this.CPDFURI = data;
        let axiosClient = axios.create({
          baseURL: this.CPDFURI,
        });
        super.initialize(axiosClient, () => {
          axiosClient.interceptors.request.use((req) => {
            if (!navigator.onLine) {
              return Promise.reject({autoSignOut: true, msg: 'offline'})
            }

            return req
          })
          axiosClient.interceptors.response.use((res) => {
            if (res.status === 200) {
              if (res.data instanceof Blob) {
                return res.data
              }
              if (res.data.data === "null") {
                return "login out"
              }

              if(res.data && res.data instanceof Object) {
                const data = res.data && JSON.parse(res.data.data).data
                const authStatus = data && data.auth_status
  
                if (authStatus === "not-authenticated") {
                  return Promise.reject({autoSignOut: true, msg: 'not-authenticated'})
                }
              }

              return res.data
            } else {
              return Promise.reject({autoSignOut: true, msg: 'service unavailable'})
            }

          })
        });
      });
    } catch (error) {
      throw error;
    }
  };
  setUserEmail(userEmail) {
    this.userEmail = userEmail
  }
  setCustomerId(customerId) {
    this.customerId = customerId
  }
  setAccessToken(accessToken, refreshToken) {
    this.accessToken = accessToken;
    storageSetItem(localStorage, 'iManageAccessToken', accessToken);
    storageSetItem(localStorage, 'iManageRefreshToken', refreshToken);
  }
  retrieveAccessToken() {
    return this.accessToken || storageGetItem(localStorage, 'iManageAccessToken');
  }
  getAccessToken(code) {
    // const url = 'auth/oauth2/token'
    const params = {
      client_id: IMANAGE_CONFIG.CLIENT_ID,
      client_secret: IMANAGE_CONFIG.CLIENT_SECRET,
      grant_type: 'authorization_code',
      code,
      redirect_uri: `${baseUrlApis.getBaseUrl()}iManageAuthrizationWin.html`,
    };
    const data = qs.stringify(params);
    const fd = new FormData();

    fd.append('method', 'POST');
    fd.append('url', `${this.iManageHost}/auth/oauth2/token`);
    fd.append('contentType', 'application/x-www-form-urlencoded');
    fd.append('responseFormat', 'json');
    fd.append('data', data);

    return this.post({ url: '/cpdfapi/v1/tools/transfer-url', data: fd });
  }
  loginOut() {
    const fd = new FormData()

    fd.append('method', 'GET');
    fd.append('url', `${this.iManageHost}/auth/logout`);
    fd.append('contentType', 'application/x-www-form-urlencoded');
    fd.append('responseFormat', 'json');
    // fd.append('data', data);

    return this.post({ url: '/cpdfapi/v1/tools/transfer-url', data: fd });
  }
  revokeAccessToken() {
    const accessToken = this.retrieveAccessToken();
    const params = {
      'access_token': accessToken
    }
    const data = qs.stringify(params)
    const fd = new FormData()

    fd.append('method', 'POST');
    fd.append('url', `${this.iManageHost}/auth/oauth2/revoke-token`);
    fd.append('contentType', 'application/x-www-form-urlencoded');
    fd.append('responseFormat', 'json');
    fd.append('data', data);

    return this.post({ url: '/cpdfapi/v1/tools/transfer-url', data: fd });
  }
  getDiscoveryInfo(accessToken) {
    const fd = new FormData();

    fd.append('method', 'GET');
    fd.append('url', `${this.iManageHost}/api`);
    fd.append('contentType', 'application/x-www-form-urlencoded');
    fd.append('responseFormat', 'json');
    fd.append('headers', JSON.stringify({ 'X-Auth-Token': accessToken }));

    return this.post({ url: '/cpdfapi/v1/tools/transfer-url', data: fd });
  }
  getDialogToken(customerId) {
    const url = `${this.iManageHost}/work/api/v2/customers/${customerId}/dialog-tokens`
    const fd = new FormData();
    const accessToken = this.retrieveAccessToken()

    fd.append('method', 'POST');
    fd.append('url', url);
    fd.append('contentType', 'application/x-www-form-urlencoded');
    fd.append('responseFormat', 'json');
    fd.append('headers', JSON.stringify({ 'X-Auth-Token': accessToken }));

    return this.post({ url: '/cpdfapi/v1/tools/transfer-url', data: fd });
  }
  createFile({libraryName, folderId, doc_profile, file}) {
    // POST /work/api/v2/customers/{customerId}/libraries/{libraryId}/folders/{folderId}/documents
    const url = `${this.iManageHost}/api/v2/customers/${this.customerId}/libraries/${libraryName}/folders/${folderId}/documents`
    const profile = {
      profile: {
        doc_profile,
        warnings_for_required_and_disabled_fields: doc_profile.warnings_for_required_and_disabled_fields,
      }
    }
    const accessToken = this.retrieveAccessToken()
    const fd = new FormData()
    
    fd.append('method', 'POST');
    fd.append('url', url);
    fd.append('contentType', 'multipart/form-data');
    fd.append('responseFormat', 'json');
    fd.append('headers', JSON.stringify({ 'X-Auth-Token': accessToken }));
    fd.append('data', JSON.stringify(profile));
    fd.append('file', file)

    return this.post({ url: '/cpdfapi/v1/tools/transfer-url', data: fd });
  }
  updateFile(params) {
    // PUT /work/api/v2/customers/{customerId}/libraries/{libraryId}/documents/{docId}/file
    const { libraryName, documentId, file, profile } = params
    const url = `${this.iManageHost}/api/v2/customers/${this.customerId}/libraries/${libraryName}/documents/${documentId}/file`

    const accessToken = this.retrieveAccessToken()
    const fd = new FormData()
    
    fd.append('method', 'PUT');
    fd.append('url', url);
    fd.append('contentType', 'multipart/form-data');
    fd.append('responseFormat', 'json');
    fd.append('headers', JSON.stringify({ 'X-Auth-Token': accessToken }));
    fd.append('data', JSON.stringify(profile));
    fd.append('file', file)

    return this.post({ url: '/cpdfapi/v1/tools/transfer-url', data: fd });
  }
  downloadFile(item, success, failed) {
    const { libraryName, documentId } = item
    const url = `${this.iManageHost}/api/v2/customers/${this.customerId}/libraries/${libraryName}/documents/${encodeURIComponent(documentId)}/download`
    const fd = new FormData();
    const accessToken = this.retrieveAccessToken()

    fd.append('method', 'GET');
    fd.append('url', url);
    fd.append('contentType', 'application/x-www-form-urlencoded');
    fd.append('responseFormat', 'json');
    fd.append('headers', JSON.stringify({ 'X-Auth-Token': accessToken }));
    fd.append('isFile', "1")

    return this.post({ url: '/cpdfapi/v1/tools/transfer-url', data: fd, config: {responseType: 'blob'} }).then((res) => {
      success && success({ blob: res, id: item.id, fileName: item.name, parents: item.parents });

      return res
    }).catch((error) => {
      failed && failed(error) 
    })
  }
}
